<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">订单信息</span>
      </div>
      <el-steps :active="2" align-center style="border-bottom:1px solid #E9E9E9;padding-bottom:20px;">
        <el-step title="准备充电" :description="rowdata.startTime" />
        <el-step title="开始充电" :description="rowdata.startTime" />
        <el-step title="结束充电" :description="rowdata.endTime" />
        <el-step title="订单支付" description="————" />
      </el-steps>
      <div style="width:100%;height:110px;;display: flex; flex-direction: row; align-items:center; border-bottom:1px solid #E9E9E9;padding-left: 6%;">
        <div style="width: 300px;color:#999999;font-size:12px;">
          <div>订单总金额</div>
          <span style="color:#1890FF;font-size:36px;">{{ rowdata.totalMoney }}</span>
          <span style="color:#333333;">元</span>
        </div>
        <div style="width: 300px;color:#999999;font-size:12px;">
          <div>订单总优惠</div>
          <span style="color:#1890FF;font-size:36px;">—</span>
          <span style="color:#333333;">元</span>
        </div>
        <div style="width: 300px;color:#999999;font-size:12px;">
          <div>实收金额</div>
          <span style="color:#1890FF;font-size:36px;">—</span>
          <span style="color:#333333;">元</span>
        </div>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="firstFormref"
          :fields="firstFormfields"
          :data-form="rowdata"
          label-width="120px"
          form-style="width:30%"
          label-position="left"
          :is-show-btn="false"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电桩实时数据最后一帧</span>
      </div>
      <div class style="padding-left:5%">
        <div style="display:flex;">
          <div style="height:50px;line-height:50px;width:30%;margin-right: 10px;">
            <span style="display:inline-block;width:60px">上送时间</span>
            <sapn style="margin-left:50px">{{ rowdata.sendTime || '--' }}</sapn>
          </div>
          <div style="height:50px;line-height:50px;width:30%;margin-right: 10px;">
            <span style="display:inline-block;width:60px">SOC</span>
            <span style="margin-left:50px">{{ rowdata.SOC || '--' }}</span>
          </div>
          <div style="height:50px;line-height:50px;width:30%;">
            <span style="display:inline-block;width:60px">电量</span>
            <span style="margin-left:50px">{{ rowdata.totalPower || '--' }}</span>
          </div>
        </div>
        <div style="display:flex;">
          <div style="height:50px;line-height:50px;width:30%;margin-right: 10px;">
            <span style="display:inline-block;width:60px">剩余时间</span>
            <span style="margin-left:50px">--</span>
          </div>
          <div style="height:50px;line-height:50px;width:30%;margin-right: 10px;">
            <span style="display:inline-block;width:60px">已充时间</span>
            <span style="margin-left:50px">{{ rowdata.totalTime || '--' }}</span>
          </div>
          <div style="height:50px;line-height:50px;width:30%;">
            <span style="display:inline-block;width:60px">充电状态</span>
            <span style="margin-left:50px">充电中</span>
          </div>
        </div>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电桩上报交易数据</span>
      </div>
      <div class style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="thirdFormref"
          :fields="thirdFormfields"
          :data-form="rowdata"
          label-width="120px"
          :is-show-btn="false"
          form-style="width:30%"
          label-position="left"
        />
      </div>
    </el-card>
    <!-- <div slot="header" class="clearfix" style="background-color:#F2F2F2; padding: 20px;">
        <span style="font-weight:600;color:#000; line-height: 10px;">电桩上报交易数据</span>
    </div> -->

    <el-card shadow="never">
      <div slot="header">
        <span class="title">电桩上报交易数据</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label-width="0px">
          <div style="color: #2593FC">温馨提示：默认结算信息为估算建议值，请确认后再行保存！</div>
        </el-form-item>
        <div style="width:500px">
          <el-form-item label="结算方式" prop="settlementType">
            <el-radio-group v-model="form.settlementType" style="width:100%;">
              <el-radio :label="0">按平台结算</el-radio>
              <!-- <el-radio :label="1">按电桩结算</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="充电电量" prop="totalPowerActual">
            <el-input v-model="form.totalPowerActual" type="number" placeholder="请输入电费单价" style="width:100%;" @input="calcServiceMoney" @blur="changeElecMoney(form.totalPowerActual)">
              <template slot="append">度</template>
            </el-input>
            <!-- <div style="margin-left: 10px">度</div> -->
          </el-form-item>
          <el-form-item label="充电时长" prop="hasChargingTimeActual">
            <el-input v-model="form.hasChargingTimeActual" type="number" placeholder="请输入充电时长" style="width:100%;" @blur="changeElecMoney(form.hasChargingTimeActual)">
              <template slot="append">分</template>
            </el-input>
            <!-- <div style="margin-left: 10px">分</div> -->
          </el-form-item>
          <el-form-item label="电费单价" prop="elecPrice">
            <el-input v-model="form.elecPrice" type="number" :disabled="hasTotalMoney" :placeholder="hasTotalMoney ? '已有充电金额，无需输入' : '请输入电费单价'" style="width:67.5%;" @input="calcAmount">
              <template slot="append">元/度</template>
            </el-input>
          </el-form-item>
          <el-form-item label="订单电费" prop="totalMoneyActual">
            <el-input v-model="form.totalMoneyActual" type="number" :disabled="hasTotalMoney" :placeholder="hasTotalMoney ? '充电金额-服务费' : '电费单价×电量'" style="width:67.5%;" @input="calcAmount">
              <template slot="append">元</template>
            </el-input>
            <!-- <div style="margin-left: 10px">元</div> -->
          </el-form-item>
          <el-form-item label="服务费单价" prop="servicePrice">
            <el-input v-model="form.servicePrice" type="number" placeholder="请输入服务费单价" style="width:67.5%;" @input="calcAmount">
              <template slot="append">元/度</template>
            </el-input>
          </el-form-item>
          <el-form-item label="订单服务费" prop="serviceMoneyActual">
            <el-input v-model="form.serviceMoneyActual" type="number" placeholder="服务费单价×电量" style="width:67.5%;" @input="calcAmount">
              <template slot="append">元</template>
            </el-input>
            <!-- <div style="margin-left: 10px">元</div> -->
          </el-form-item>
          <el-form-item label="结算总金额" prop="totalMoneyAll">
            <el-input v-model="form.totalMoneyAll" type="number" placeholder="自动计算" style="width:67.5%;" :disabled="true">
              <template slot="append">元</template>
            </el-input>
            <!-- <div style="margin-left: 10px">元</div> -->
          </el-form-item>
          <el-form-item label="处理原因" prop="settlementDesc">
            <el-input v-model="form.settlementDesc" type="textarea" :rows="4" placeholder="请输入处理原因" />
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Daichulidingdanxiangqing',
  components: {},
  data() {
    return {
      rowdata: {},
      firstFormfields: [
        {
          label: '充电单号',
          type: 'div',
          style: 'width:100%',
          prop: 'startChargeSeq'
        },
        {
          label: '用户账号',
          type: 'div',
          style: 'width:100%',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          type: 'div',
          style: 'width:100%',
          prop: 'userName'
        },
        {
          label: '充电卡号',
          type: 'div',
          style: 'width:100%',
          prop: 'cardNum'
        },
        {
          label: '充电车辆',
          type: 'div',
          style: 'width:100%',
          prop: 'plateNumber'
        },
        {
          label: '归属企业',
          type: 'div',
          style: 'width:100%',
          prop: 'belongOrg'
        },
        {
          label: '运营商流水号',
          type: 'div',
          style: 'width:100%',
          prop: 'outStartChargeSeq'
        },
        {
          label: '流量方流水号',
          type: 'div',
          style: 'width:100%',
          prop: 'hlhtStartChargeSeq'
        },
        {
          label: '终端名称',
          type: 'div',
          style: 'width:100%',
          prop: 'connectorName'
        },
        {
          label: '电桩品牌',
          type: 'div',
          style: 'width:100%',
          prop: 'equipmentBrand'
        },
        {
          label: '电桩型号',
          type: 'div',
          style: 'width:100%',
          prop: 'equipmentModel'
        },
        {
          label: '电桩功率',
          type: 'div',
          style: 'width:100%',
          prop: 'equipPower'
        },
        {
          label: '电站名称',
          type: 'div',
          style: 'width:100%',
          prop: 'stationName'
        },
        {
          label: '运营商',
          type: 'div',
          style: 'width:100%',
          prop: 'orgName'
        },
        {
          label: '运营商属性',
          type: 'div',
          style: 'width:100%',
          prop: 'attrValue'
        }
      ],
      thirdFormfields: [
        {
          label: '充电时长',
          type: 'div',
          style: 'width:100%',
          prop: 'totalTime'
        },
        {
          label: '充电电量',
          type: 'div',
          style: 'width:100%',
          prop: 'totalPower'
        },
        {
          label: '充电金额',
          type: 'div',
          style: 'width:100%',
          prop: 'totalMoney'
        }
      ],

      form: {
        hasChargingTimeActual: '',
        serviceMoneyActual: '',
        servicePrice: '',
        elecPrice: '',
        totalMoneyActual: '',
        totalMoneyAll: '',
        settlementDesc: '',
        settlementType: 0,
        totalPowerActual: ''
      },
      hasTotalMoney: false,
      rules: {
        totalPowerActual: [{ required: true, message: '请输入充电电量', trigger: 'blur' }],
        hasChargingTimeActual: [{ required: true, message: '请输入充电时长', trigger: 'blur' }], //, {pattern: /[1-9]\d*/,message: "请输入正确充电时长",trigger: "change"}
        totalMoneyActual: [{ required: true, message: '请输入订单电费', trigger: 'blur' }],
        serviceMoneyActual: [{ required: true, message: '请输入订单服务费', trigger: 'blur' }],
        settlementDesc: [{ required: true, message: '请输入处理原因', trigger: 'blur' }]
      },
      id: ''
    }
  },
  computed: {},
  mounted() {
    this.getDataDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    },

    async save() {
      try {
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }
      const data = {
        id: this.id,
        settlementType: this.form.settlementType,
        hasChargingTimeActual: this.form.hasChargingTimeActual,
        serviceMoneyActual: this.form.serviceMoneyActual,
        elecPrice: this.form.elecPrice,
        totalMoneyActual: this.form.totalMoneyActual,
        totalMoneyAll: this.form.totalMoneyAll,
        settlementDesc: this.form.settlementDesc,
        totalPowerActual: this.form.totalPowerActual
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/order/post',
        data: data,
        method: 'post',
        callback: resp => {
          this.$router.go(-1)
        }
      })
    },

    changeElecMoney(val) {},

    changeServiceMoney(val) {},

    // 自动计算：服务费 = 服务费单价×电量；电费 = (有充电金额? 充电金额-服务费 : 电费单价×电量)；结算总金额 = 电费 + 服务费
    calcAmount() {
      const price = parseFloat(this.form.servicePrice)
      const elecPrice = parseFloat(this.form.elecPrice)
      const power = parseFloat(this.form.totalPowerActual)
      const totalMoney = parseFloat(this.rowdata.totalMoney)
      // 服务费自动算（单价×电量），用户也可手动覆盖
      if (!isNaN(price) && !isNaN(power)) {
        this.form.serviceMoneyActual = (price * power).toFixed(2)
      }
      // 电费：有充电金额则用 充电金额 - 服务费；否则用电费单价 × 电量
      if (this.hasTotalMoney && !isNaN(totalMoney)) {
        const service = parseFloat(this.form.serviceMoneyActual)
        if (!isNaN(service)) {
          this.form.totalMoneyActual = (totalMoney - service).toFixed(2)
        }
      } else if (!isNaN(elecPrice) && !isNaN(power)) {
        this.form.totalMoneyActual = (elecPrice * power).toFixed(2)
      }
      // 结算总金额 = 电费 + 服务费
      const elec = parseFloat(this.form.totalMoneyActual)
      const service = parseFloat(this.form.serviceMoneyActual)
      if (!isNaN(elec) && !isNaN(service)) {
        this.form.totalMoneyAll = (elec + service).toFixed(2)
      } else {
        this.form.totalMoneyAll = ''
      }
    },

    getDataDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/order/getPendingOrderDetail',
        data: data,
        method: 'get',
        callback: resp => {
          this.rowdata = resp
          // this.form.hasChargingTimeActual = resp.totalTime
          if (resp.totalTime.indexOf('分')) {
            var index = resp.totalTime.indexOf('分')
            this.form.hasChargingTimeActual = resp.totalTime.substring(0, index)
          } else if (resp.totalTime.indexOf('秒')) {
            var index = resp.totalTime.indexOf('秒')
            this.form.hasChargingTimeActual = resp.totalTime.substring(0, index) / 60
          } else if (resp.totalTime.indexOf('时')) {
            var index = resp.totalTime.indexOf('时')
            this.form.hasChargingTimeActual = resp.totalTime.substring(0, index) * 60
          }
          this.form.totalPowerActual = resp.totalPower
          this.hasTotalMoney = resp.totalMoney !== null && resp.totalMoney !== undefined && resp.totalMoney !== '' && !isNaN(parseFloat(resp.totalMoney))
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.iconfont {
  width: 50px;
  height: 50px;
  margin: auto;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/processingPending.vue